// extracted by mini-css-extract-plugin
export var additionalInfo = "styles-module--additionalInfo--4af08";
export var additionalInfo2 = "styles-module--additionalInfo2--23b9e";
export var iconWrapper = "styles-module--iconWrapper--48fd6";
export var imgWrapper = "styles-module--imgWrapper--7e901";
export var participantWrapper = "styles-module--participantWrapper--58b6b";
export var withoutImage = "styles-module--withoutImage--422f0";